import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import BodyClassName from 'react-body-classname';
import Modal from '../Modal';
import './style.scss';

const LoanCardTooltip = ({ offset, className, children }) => {
  const [isActive, setIsActive] = useState(false);
  const tooltip = useRef(null);

  const handleTrigger = () => {
    setIsActive(!isActive);
  };

  const handleClickOutside = (event) => {
    if (tooltip.current && !tooltip.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        className={`${className} loanCard-tooltip tooltip ${offset !== 0 ? `offset${offset}` : ''} ${isActive ? 'active' : ''}`}
        ref={tooltip}
      >
        <div
          className="trigger"
          onClick={handleTrigger}
        />
      </div>
      {
        isActive && (
          <BodyClassName className="overflowHidden">
            <Modal>
              <div className="close" onClick={handleTrigger} />
              <div className="card-content security-error">
                {children}
              </div>
            </Modal>
          </BodyClassName>
        )
      }
    </>
  );
};

LoanCardTooltip.propTypes = {
  offset: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LoanCardTooltip.defaultProps = {
  offset: 0,
  className: '',
};

export default LoanCardTooltip;
